import React from "react";

interface LoadingIndicatorProps {
  message: string;
  errorMessage?: string | null;
}

export default function LoadingIndicator({ message, errorMessage }: LoadingIndicatorProps) {
  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100 dark:bg-gray-900">
      <div className="p-4 bg-white dark:bg-gray-800 rounded shadow-md max-w-md w-full">
        <div className="flex items-center space-x-3">
          <div className="w-8 h-8 border-4 border-t-blue-500 border-b-gray-200 border-l-gray-200 border-r-gray-200 rounded-full animate-spin dark:border-b-gray-700 dark:border-l-gray-700 dark:border-r-gray-700"></div>
          <p className="text-gray-700 dark:text-gray-300">{message}</p>
        </div>
        {errorMessage && (
          <div className="p-4 mt-4 text-sm text-red-700 bg-red-100 rounded-lg dark:bg-red-900/30 dark:text-red-400">
            {errorMessage}
          </div>
        )}
      </div>
    </div>
  );
} 